var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LuckyWheel',{ref:"myLucky",attrs:{"blocks":_vm.blocks,"buttons":_vm.buttons,"prizes":_vm.prizes,"height":"75vw","width":"75vw"},on:{"end":_vm.endCallback,"start":_vm.startCallback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }